/**
 * Query keys for Claim Campaign API hooks.
 *
 * Centralized query keys enable consistent cache invalidation across all claim campaign hooks.
 */
import type { ListClaimCampaignsParams, ListClaimCodesParams, ListClaimRecordsParams } from '~/services/LuxLoyalty';

export const claimCampaignQueryKeys = {
  all: ['loyalty', 'claim-campaigns'] as const,
  lists: () => [...claimCampaignQueryKeys.all, 'list'] as const,
  list: (filters?: ListClaimCampaignsParams) => [...claimCampaignQueryKeys.lists(), filters] as const,
  details: () => [...claimCampaignQueryKeys.all, 'detail'] as const,
  detail: (id: string) => [...claimCampaignQueryKeys.details(), id] as const,
  codes: (campaignId: string) => [...claimCampaignQueryKeys.all, 'codes', campaignId] as const,
  codesList: (campaignId: string, filters?: ListClaimCodesParams) =>
    [...claimCampaignQueryKeys.codes(campaignId), filters] as const,
  claims: (campaignId: string) => [...claimCampaignQueryKeys.all, 'claims', campaignId] as const,
  claimsList: (campaignId: string, filters?: ListClaimRecordsParams) =>
    [...claimCampaignQueryKeys.claims(campaignId), filters] as const,
};
